import createIcon from '../../createIcon';

/**
 * @component @name AdUnits
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMUg3QzUuOSAxIDUgMS45IDUgM1YyMUM1IDIyLjEgNS45IDIzIDcgMjNIMTdDMTguMSAyMyAxOSAyMi4xIDE5IDIxVjNDMTkgMS45IDE4LjEgMSAxNyAxWk0xNyAxOUg3VjVIMTdWMTlaTTggNkgxNlY4SDhWNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AdUnits = createIcon('AdUnits', [
  [
    'path',
    {
      d: 'M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM17 19H7V5H17V19ZM8 6H16V8H8V6Z',
      key: '1qxdiq',
    },
  ],
]);

export default AdUnits;
